export const PASO_ASSESSMENT = 1;
export const PASO_BOM = 2;
export const PASO_PROPUESTA_TECNICO_FUNCIONAL = 3;
export const PASO_PROPUESTA_COMERCIAL = 4;
export const PASO_KICKOFF = 6;
export const PASOS_GENERADOS_DESDE_MACHOTE = [PASO_BOM, PASO_PROPUESTA_TECNICO_FUNCIONAL, PASO_PROPUESTA_COMERCIAL];
export const DIAS_LIMITE_PROYECTO_DEFAULT = 7;
export const PASO_SIN_RETROCESO = 4;
export const PASO_MAX_VERSIONABLE = 4;
export const PASO_MAX_ARCHIVOS_MULTIPLES = 4;
export const NOMBRE_DATOS_BOM = "datos-bom.json";
export const esPasoMultiple = (numero) => numero <= PASO_MAX_ARCHIVOS_MULTIPLES;
export const SIN_ARCHIVOS = [];
export const FIRMANTE_VACIO = { nombre: "", puesto: "", correo: "", celular: "" };
export const soloDigitosCelular = (valor) => valor.replace(/\D/g, "").slice(0, 10);
export const MONEDA_DEFAULT = "USD";
export const TIENE_IVA_DEFAULT = true;

export const pasos = [
  {
    numero: 1,
    titulo: "Assessment",
    entrada: "Documento de Assessment del proyecto (mediciones, AP, cobertura, planos).",
    entradaAccept: ".pdf,.doc,.docx,.xls,.xlsx",
    salida: "Assessment validado",
    formatoSalida: "PDF",
  },
  {
    numero: 2,
    titulo: "BOM",
    entrada: "Assessment validado del paso anterior.",
    entradaAccept: ".pdf,.doc,.docx,.xls,.xlsx",
    salida: "Bill of Materials (BOM)",
    formatoSalida: "Excel / PDF",
  },
  {
    numero: 3,
    titulo: "Propuesta técnico-funcional",
    entrada: "BOM aprobado del paso anterior.",
    entradaAccept: ".pdf,.doc,.docx,.xls,.xlsx",
    salida: "Propuesta técnico-funcional",
    formatoSalida: "Word / PDF",
  },
  {
    numero: 4,
    titulo: "Propuesta comercial",
    entrada: "Propuesta técnico-funcional del paso anterior.",
    entradaAccept: ".pdf,.doc,.docx",
    salida: "Propuesta comercial",
    formatoSalida: "Word / PDF",
  },
  {
    numero: 5,
    titulo: "Agreement",
    entrada: "Propuesta comercial aprobada por el cliente.",
    entradaAccept: ".pdf,.doc,.docx",
    salida: "Agreement",
    formatoSalida: "Word / PDF",
  },
  {
    numero: 6,
    titulo: "Kick-off",
    entrada: "Agreement firmado por el cliente.",
    entradaAccept: ".pdf,.doc,.docx",
    salida: "Presentación de Kick-off",
    formatoSalida: "PowerPoint",
  },
];

export const EMPRESAS = [
  { id: "Netjer", nombre: "Netjer", logo: `${process.env.PUBLIC_URL || ""}/img/NJ-Logotipo.png` },
  { id: "Rexten", nombre: "Rexten", logo: `${process.env.PUBLIC_URL || ""}/img/rexten.png` },
];

const MESES_ES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

export const formatearFechaLarga = (fecha) => `${fecha.getDate()} de ${MESES_ES[fecha.getMonth()]} de ${fecha.getFullYear()}`;

export const formatearTamanio = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  const unidades = ["B", "KB", "MB", "GB"];
  let valor = bytes;
  let i = 0;
  while (valor >= 1024 && i < unidades.length - 1) {
    valor /= 1024;
    i += 1;
  }
  return `${valor.toFixed(1)} ${unidades[i]}`;
};
